import apiClient from '../api/apiClient';
import {
  SYSTEM_REST_API_BASE_URL,
  ADMIN_REST_API_BASE_URL,
  MANAGER_REST_API_BASE_URL,
  USER_REST_API_BASE_URL,
} from '../config';

export const getMenuSectionsByLoggedInUser = () =>
  apiClient.get(`${SYSTEM_REST_API_BASE_URL}/sections`);
export const getAdminMenuByLoggedInUser = () =>
  apiClient.get(`${ADMIN_REST_API_BASE_URL}/subscription/apps`);
export const getManagerMenuByLoggedInUser = () =>
  apiClient.get(`${MANAGER_REST_API_BASE_URL}/subscription/apps`);
export const getUserMenuByLoggedInUser = () =>
  apiClient.get(`${USER_REST_API_BASE_URL}/subscription/apps`);

export default apiClient;
